<template>
    <div class="type-box" v-if="match.sportType === '篮球' && !jetlympic">
      <div class="card" v-if="topPlayers.length > 0">
        {{ $t('match.homeTabs.text_8') }} <span @click="goMatchData">{{ $t('match.homeTabs.text_9') }}</span>
      </div>
      <div class="activity-football-list" v-if="topPlayers.length > 0">
        <div class="item-box" :style="{width:topPlayers.length * 222 + 'px'}">
          <div class="item" v-for="item in topPlayers" :key="item.id">
            <div class="top">
              <i></i>
              <span></span>
              <b>{{ $t('match.homeTabs.' + item.type) }}</b>
            </div>
            <div style="width: 100%; height: 35px;"></div>
            <div class="mvp-score">
              {{ item.top || 0 }}
              <span>场均</span>
            </div>
            <div class="mvp-team-member">
              <img :src="filterImage(item.player.avatar)" v-if="item.player.avatar">
              <img src="@/assets/images/Mensingles.png" v-else>
              <div class="mvp-understand">
                <div>{{ item.player.trueName }}</div>
                <span>{{item.player.number}}号/{{item.player.position?item.player.position+'/':''}}{{item.player.teamName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
// import teams from './TeamList'
export default {
  props: {
    topPlayers: {
      type: Array,
      default: () => []
    },
    match: {
      type: Object,
      default: () => {}
    },
    teamList: {
      type: Array,
      default: () => []
    },
    matchId: String
  },
  // components: { teams },
  data() {
    return {
      select: '',
      aList: [],
      bList: [],
      jetlympic: false
    }
  },
  watch: {
    teamList: {
      handler() {
        this.select = this.match.groupNames && this.match.groupNames[0] && this.match.groupNames[0].groupName
        this.aList = this.teamList.filter(res => {
          return res.groupName === this.select
        })
        this.bList = this.teamList.filter(res => {
          return res.groupName !== this.select
        })
      }
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
  },
  methods: {
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    goMatchData() {
      this.$router.push({ path: 'match-data', query: { matchId: this.matchId }})
    }
  }
}
</script>

<style scoped lang="scss">
.type-box{
  .card {
    background-color: #fff;
    font-size: 16px;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    span{
      font-size: 12px;
      color: #ababab;
    }
  }
  .activity-football-list{
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    background-color: #fff;
    overflow: hidden;
    overflow-x: auto !important;
    &::-webkit-scrollbar {
      display: none;
    }
    .item-box{
      display: flex;
      .item{
        position: relative;
        width: 222px;
        margin-right: 10px;
        box-sizing: border-box;
        background-color: #F8F8F8;
        &:last-child{
          margin-right: 0;
        }
        .top{
          position: absolute;
          height: 35px;
          i{
            position: absolute;
            z-index: 1;
            background-color: #0D7096;
            height: 28px;
            width: 30px;
          }
          span{
            position: absolute;
            display: block;
            width: 80px;
            height: 28px;
            background-color: #EC4E4E;
            transform: skewX(-30deg);
            top: 0;
            left: 8px;
            z-index: 2;
          }
          b{
            font-weight: 400;
            position: absolute;
            left: 14px;
            top: 6px;
            width: 70px;
            color: white;
            z-index: 3;
            font-size: 12px;
          }
        }
        .mvp-score{
          font-size: 30px;
          color: #4A4A4A;
          padding-left: 15px;
          font-weight: 300;
          span{
            font-size: 12px;
            color: #9B9B9B;
          }
        }
        .mvp-team-member{
          padding: 10px 15px;
          display: flex;
          align-items: center;
          img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
          }
          .mvp-understand{
            font-size: 14px;
            color: #191919;
            font-weight: 500;
            span{
              font-size: 12px;
              color: #9B9B9B;
            }
          }
        }
      }
    }
  }
  .tab-fix{
    position: relative;
    margin-top: 10px;
    display: flex;
    background-color: #fff;
    .item{
      width: 50%;
      text-align: center;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      .select{
        color: #cc3232;
        border-bottom: 2px solid #cc3232;
      }
    }
    .i{
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1px;
      height: 30px;
      background-color: #f0f0f0;
      transform: translate(-50%,-50%);
    }
  }

  .video{
      padding: 10px 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      background-color: #fff;
      .item{
        width: 48%;
        font-size: 14px;
        img{
          width: 100%;
        }
        div{
          position: relative;
        }
        .icon{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 40px;
          height: 40px;
        }
      }
    }
}
</style>
